interface Props {
  isFiltered: boolean;
}

const WorkspaceUsersEmptyState: React.FC<Props> = ({ isFiltered }) => (
  <div className="flex flex-col items-center justify-center py-12 text-center">
    <p className="text-sm text-gray-500">
      {isFiltered
        ? 'No users found matching your search'
        : 'No users found in this workspace'}
    </p>
  </div>
);

export default WorkspaceUsersEmptyState;
